import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    details: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: 0,
      marginTop: theme.spacing(6),
    },
    detailsItem: {
      display: "flex",
      flexDirection: "column",
    },
    sectionTitle: {
      color: theme.gray800,
      fontSize: "16px",
      lineHeight: "24px",
    },
    smallText: {
      color: theme.gray500,
      fontSize: "14px",
      lineHeight: theme.spacing(10),
    },
    largeText: {
      color: theme.gray800,
      fontSize: "16px",
      lineHeight: theme.spacing(12),
    },
    gridContainer: {
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing(8),
    },
    fraudSectionContainer: {
      padding: theme.spacing(6, 8),
      borderBottom: `1px solid ${theme.gray100}`,
      display: "flex",
    },
    hidden: { overflow: "hidden" },
    visible: { overflow: "visible" },
    chipsContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: theme.spacing(4),
    },
    chip: {
      borderRadius: "4px",
    },
    textWithTooltipBox: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(4),
    },
    tooltip: {
      height: "14px",
      margin: 0,
      width: "14px",
    },
    tooltipTitle: {
      color: theme.gray800,
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "24px",
    },
    tooltipDescription: {
      color: theme.gray500,
      fontSize: "12px",
      lineHeight: "20px",
      marginTop: theme.spacing(2),
    },
    showMoreBtn: {
      fontSize: "13px",
      textDecoration: "underline",
      "&:hover": {
        textDecoration: "underline",
      },
    },
    customAttributesModal: {
      "& > div": {
        marginBottom: theme.spacing(2),
      },
    },
    scrollable: {
      overflow: "auto",
    },
    detailsSection: {
      flexDirection: "row",
      flexGrow: 1,
      alignItems: "flex-start",
    },
  }),
);
